import { useCallback, useEffect, useState } from 'react';
import { useIsFirstRender } from '@agro1desenvolvimento/react-hooks';
import LocalStorageService, { LocalStoreData } from '../services/local-storage';

const useLocalStore = <K extends keyof LocalStoreData>(key: K) => {
  const [value, setValue] = useState(() => LocalStorageService.getItem(key));
  const isFirstRender = useIsFirstRender();

  const atualizaValue = useCallback(
    (newValue: LocalStoreData[K]) => {
      LocalStorageService.setItem(key, newValue);
      setValue(newValue);
    },
    [setValue, key],
  );

  useEffect(() => {
    if (!isFirstRender) {
      setValue(LocalStorageService.getItem(key));
    }

    const unsubscriber = LocalStorageService.addOnChange((event) => {
      if (event.action === 'clear') {
        setValue(null);
      } else if (event.key === key) {
        setValue(event.value as LocalStoreData[K]);
      }
    });

    return () => {
      unsubscriber();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { value, setValue: atualizaValue };
};

export default useLocalStore;
